// Utilities
import { flexParent } from "@ms/planner-generic-controls/lib/local/utilities/Mixin.styles";
import { makeStyles } from "@fluentui/react-components";
const shimmerWidth = "288px";
const shimmerMargin = "17px";
const taskCardPlaceHolderShimmerHeight = "108px"; // Default height for task card
const addTaskCardPlaceHolderShimmerHeight = "40px"; // Height for add task card
/**
 * Returns the styles for the root container.
 */ const rootStyles = {
    ...flexParent("row"),
    margin: "20px"
};
/**
 * Styles for the add task shimmer.
 */ const addTaskShimmerStyles = {
    marginBottom: shimmerMargin,
    height: addTaskCardPlaceHolderShimmerHeight
};
/**
 * Styles for the task card shimmer.
 */ const taskCardShimmerStyles = {
    margin: "4px 0px 8px 0px",
    height: taskCardPlaceHolderShimmerHeight
};
/**
 * Styles for the column header shimmer.
 */ const columnHeaderShimmerStyles = {
    marginBottom: `calc(${shimmerMargin} - 4px)`
};
/**
 * Styles for the column shimmer
 */ const columnShimmerStyles = {
    ...flexParent("column"),
    margin: "0px 14px",
    width: shimmerWidth
};
/**
 * Returns a hook with styles for the TaskBoardViewPlaceHolder component
 */ export const useTaskBoardViewPlaceHolderStyles = makeStyles({
    root: rootStyles,
    columnShimmer: columnShimmerStyles,
    addTaskShimmer: addTaskShimmerStyles,
    taskCardShimmer: taskCardShimmerStyles,
    columnHeaderShimmer: columnHeaderShimmerStyles
});
